import { createFileRoute } from '@tanstack/react-router'
import { Frontpage } from '../../modules/home/Frontpage'

// Auth is handled by _app layout's beforeLoad
export const Route = createFileRoute('/_app/home')({
  component: Frontpage,
})
